import React from 'react';

/**
 * Full-bleed 4:3 image cards, one per animation style. Four across on
 * desktop, two across under 720px. The selected card gets a blue outline
 * and a check badge. Used by the video-story and storybook creators.
 */
const AnimationStylePicker = ({ options = [], value, onChange, className = '' }) => (
  <>
    <div
      style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: 12 }}
      className={`style-grid ${className}`.trim()}
    >
      {options.map((opt) => {
        const active = value === opt.id;
        return (
          <button
            key={opt.id}
            type="button"
            onClick={() => onChange && onChange(opt.id)}
            aria-pressed={active}
            aria-label={opt.label}
            style={{
              all: 'unset', cursor: 'pointer', position: 'relative', display: 'block',
              aspectRatio: '4 / 3', borderRadius: 18, overflow: 'hidden', background: '#0B1A33', boxSizing: 'border-box',
              outline: active ? '3px solid #0065F8' : '1px solid rgba(11,26,51,0.10)', outlineOffset: -1,
              boxShadow: active ? '0 10px 24px rgba(0,101,248,0.25)' : '0 4px 12px rgba(11,26,51,0.08)',
              transform: active ? 'scale(1.0)' : 'scale(0.985)',
              opacity: active ? 1 : 0.92,
              transition: 'outline-color 160ms, box-shadow 160ms, transform 160ms, opacity 160ms',
            }}
          >
            {opt.preview_url && (
              <img src={opt.preview_url} alt="" loading="lazy" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
            )}
            <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(0,0,0,0.80) 0%, rgba(0,0,0,0.30) 38%, rgba(0,0,0,0) 62%)' }} />
            {active && (
              <span style={{ position: 'absolute', top: 8, right: 8, width: 26, height: 26, borderRadius: '50%', background: '#0065F8', color: '#fff', display: 'grid', placeItems: 'center', fontSize: 15, fontWeight: 800, boxShadow: '0 2px 6px rgba(0,0,0,0.3)' }}>✓</span>
            )}
            <div style={{ position: 'absolute', left: 12, right: 12, bottom: 12, color: '#fff', fontWeight: 800, fontSize: 18, lineHeight: 1.1, textShadow: '0 1px 6px rgba(0,0,0,0.6)' }}>{opt.label}</div>
          </button>
        );
      })}
    </div>
    <style>{`
      @media (max-width: 720px) {
        .style-grid { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; }
      }
    `}</style>
  </>
);

export default AnimationStylePicker;
